import { forwardRef, type ComponentPropsWithoutRef, type ElementRef } from 'react';
import { Content } from '@radix-ui/react-accordion';

export type AccordionContentProps = ComponentPropsWithoutRef<typeof Content>;

const AccordionContent = forwardRef<ElementRef<typeof Content>, AccordionContentProps>(
  ({ className, children, ...props }, ref) => (
    <Content
      ref={ref}
      className="overflow-hidden text-sm transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
      {...props}>
      <div className={className}>{children}</div>
    </Content>
  )
);

AccordionContent.displayName = Content.displayName;

export default AccordionContent;
